import { combineReducers } from 'redux';
import location from './reducer-router';
import query from '../../contactUs/reducers/reducer-query-params';
import notifier from '../../contactUs/reducers/reducer-notifier';
import helpcenterAlerts from '../../contactUs/reducers/reducer-helpcenter-alerts';
import autoComplete from '../../contactUs/reducers/reducer-auto-complete';
import searchFilters from './reducer-search-filter-form';
import searchResult from './reducer-search-results';
import contactReason from './reducer-top-contact-reason';
import mobileFilter from './reducer-mobile-filter';

import contentToggle from './reducer-content-toggle';
import article from './reducer-article-panel';
import topicList from './reducer-topic-list';
import popular from './reducer-popular-list';
import articleList from './reducer-article-list';
import breadcrumb from './reducer-breadcrumb';
import community from './reducer-community-results';
import machineArticle from './reducer-machine-article';
import chatBot from './reducer-chat-bot';
import chatBotFAQ from '../../contactUs/reducers/reducer-chat-bot';
import chatInEligibleModal from '../../contactUs/reducers/reducer-chat-ineligible-modal';
import speechRecognition from '../../contactUs/reducers/reducer-speech-recognition';
import postChatBotEligibility from '../../contactUs/reducers/reducer-postchatbot-eligibility';
import ocp from '../../common/ocpCardPrompt/reducer-ocpComponent';
import crawlIntentTopic from '../../contactUs/reducers/reducer-crawl-intent-topic';

import modal from '../../contactUs/reducers/reducer-login-modal';
import app from './reducer-app';
import defaultPCCArticles from './reducer-default-PCC';
import authPrompt from './reducer-auth-prompt';
import config from '../../refundHelp/reducers/reducer-config-setup';
import icfGuide from './reducer-icf-guide';
import icfPage from './reducer-icf-page';
import allICFGuides from './reducer-allICF-guides';
import qualtricsActiveIntercept from './reducer-qualtrics';

// dispute transactions
import disputeTransactions from './reducer-dispute-transactions';

// Trackers
import trackers from '../../common/trackerAlerts/reducer-trackers';

// Home V2
import homeV2Reducers from '../../../jsV2/home/store/rootReducer';

// ContactUs V2
import contactUsV2Reducers from '../../../jsV2/contactUs/store/rootReducer';

// For enabling L3Topic
import L3TopicList from './reducer-L3Topic-list';

// Innovation Guild: Search only experiment
import contactChannels from '../../contactUs/reducers/reducer-contact-channels';

// Innovation Guild: Search only experiment
import stepUp from '../../contactUs/reducers/reducer-step-up';

// Innovation Guild: Search only experiment
import selectResult from '../../contactUs/reducers/reducer-topic-select-result';

// Innovation Guild: Search only experiment
import callUs from '../../contactUs/reducers/reducer-call-us';

// SAMPLE APP state

// {
//   location,
//   topicTree: {
//     experience: 'personal',
//     topicTree: [],
//   },
//   topicList: {
//     experience: 'personal',
//     topicId: '',
//     topicList: [],
//   },
//   article: {
//     experience: 'personal',
//     articleId: '',
//     relatedArticle: [],
//   },
// };

const rootReducers = combineReducers({
  location,
  query,
  notifier,
  helpcenterAlerts,
  autoComplete,
  searchFilters,
  searchResult,
  contactReason,
  mobileFilter,
  topicList,
  contentToggle,
  article,
  articleList,
  machineArticle,
  popular,
  breadcrumb,
  community,
  chatBot,
  chatBotFAQ,
  modal,
  chatInEligibleModal,
  speechRecognition,
  postChatBotEligibility,
  app,
  defaultPCCArticles,
  authPrompt,
  config, // initial config data, imported from refund help reducer
  icfGuide,
  icfPage,
  allICFGuides,
  disputeTransactions,
  trackers,
  ...homeV2Reducers, // Merging new redux store with existing store.
  ...contactUsV2Reducers, // Merging the contactUsV2 (contactUs Redesign) redux store with existing store.
  qualtricsActiveIntercept,
  L3TopicList,
  contactChannels, // Innovation Guild: search only experiment
  stepUp, // Innovation Guild: search only experiment
  persistedStepUp: stepUp, // Innovation Guild: search only experiment
  selectResult, // Innovation Guild: search only experiment
  smcResultKeeper: selectResult, // Innovation Guild: search only experiment. HACK: user redux-persist to keep user select topic tree info
  callUs, // Innovation Guild: search only experiment
  ocp,
  crawlIntentTopic,
});

export default rootReducers;
